import React, { FC } from 'react';
import { ServerError } from '@cld/empty-state';
import { useFetchCodeSnippets } from './hooks';
import { SdkCodeSnippetsSkeleton } from './components/SdkCodeSnippetsSkeleton';
import { SdkCodeSnippetsUncontrolled } from './SdkCodeSnippetsUncontrolled';
import { SdkCodeSnippetsProps } from './types';

export interface SdkCodeSnippetsAsyncProps extends SdkCodeSnippetsProps {
  url: string;
  includeImports?: boolean;
}

export const SdkCodeSnippetsAsync: FC<React.PropsWithChildren<SdkCodeSnippetsAsyncProps>> = ({ url, includeImports, ...rest }) => {
  const { snippets, isLoading, isError, parsedUrl } = useFetchCodeSnippets({ url, includeImports: Boolean(includeImports) });
  return (
    <>
      {isLoading && <SdkCodeSnippetsSkeleton {...rest} />}
      {snippets && <SdkCodeSnippetsUncontrolled snippets={snippets} parsedUrl={parsedUrl} {...rest} />}
      {isError && <ServerError />}
    </>
  );
};
